// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VModal from 'vue-js-modal';
import VueGtm from 'vue-gtm';

Vue.config.productionTip = false;

Vue.use(VModal)
  .use(VueGtm, {
    id: 'GTM-PGSB2HJ', // Your GTM ID
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js